import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const CompanySetup: React.FC = () => {
  const { setupCompany, logout } = useAuth();
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!companyName.trim()) {
      setError('Введите название компании');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await setupCompany(companyName.trim());
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка при создании компании');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Fin Calendar</h1>
        <p className="text-gray-600 mb-6">
          Для начала работы укажите название вашей компании. Вы станете её администратором.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Название компании
            </label>
            <input
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="ООО «Ромашка»"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="mb-4 p-2 bg-red-100 text-red-800 rounded-md text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors"
          >
            {loading ? 'Создание...' : 'Создать компанию'}
          </button>
        </form>

        <p className="text-xs text-gray-500 mt-4 text-center">
          Если ваша компания уже зарегистрирована, попросите администратора отправить вам приглашение.
        </p>

        <button
          onClick={logout}
          className="mt-4 w-full py-2 px-4 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors text-sm"
        >
          Выйти
        </button>
      </div>
    </div>
  );
};

export default CompanySetup;
